const FOCUSABLE_SELECTOR =
  'a[href]:not([tabindex="-1"]), area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]):not(.hidden), [tabindex="0"]';

const getFocusableElements = (
  parentElement,
  { selector = FOCUSABLE_SELECTOR, skipHidden = false } = {}
) => {
  if (parentElement) {
    const focusableElements = parentElement.querySelectorAll(selector);

    const focusableElementsArray = Array.from(focusableElements);

    // Opt-in only: focus traps can run before their container is visible
    if (skipHidden) {
      return focusableElementsArray.filter(
        element => element.checkVisibility?.() ?? true
      );
    }

    return focusableElementsArray;
  }

  return [];
};

export default getFocusableElements;
